export function getRuntimeBasePath(basePath: string) {
  if (isEplatformAppRuntime()) {
    if (typeof window !== 'undefined') {
      return `${window.location.origin}/${basePath}`;
    }
  }

  return basePath;
}

function isEplatformAppRuntime() {
  return process.env.GATSBY_APP_RUNTIME_TARGET?.includes('eplatform');
}
